import React from 'react';

const Creator = () => {
  return (
    <main className="min-h-screen bg-[#f5ede4] text-[#1f1f1f] flex items-center justify-center px-6 py-6">
      <section className="w-full max-w-3xl bg-white rounded-2xl shadow-lg p-8 md:p-12 border border-[#e6dbcd]">
        <p className="text-sm uppercase tracking-[0.2em] text-[#7b6b55]">Website Creator</p>
        <h1 className="mt-3 text-4xl md:text-5xl leading-tight font-semibold text-[#1c2f2b]">
          Sohail Asghar
        </h1>
        <p className="mt-5 text-base md:text-lg text-[#3d3d3d]">
          This website was created by Sohail Asghar. Visit the official portfolio website for more
          details and contact information.
        </p>
        <a
          href="https://sohailasghar.site"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block mt-8 px-6 py-3 rounded-full bg-[#002726] text-white font-medium hover:opacity-90 transition-opacity"
        >
          Visit sohailasghar.site
        </a>
      </section>
    </main>
  );
};

export default Creator;
